import { useLocation } from "react-router-dom";
import { Container } from "./styles";
import { useMediaQuery } from "react-responsive";
import ViewGerenciarAnuncioVendaMobile from "./components/ViewMobile";
import ViewGerenciarAnuncioVendaDesktop from "./components/ViewDesktop";
import { useAnuncioPropriedade } from "./hooks/useAnuncioPropriedade";
import { useInteressadoAnuncio } from "./hooks/useInteressadoAnuncio";
import { useVisualizacao } from "./hooks/useVisualizacao";
import { formatDate } from "../../uteis/dateUtils";
import { useState } from "react";
import ModalEditarAnuncio from "./components/ModalEditarAnuncio";
import { Skeleton } from "antd";
import { useBuscarCotaUsuario } from "./hooks/useBuscarCotaUsuario";
import ModalInteressados from "./components/ModalInteressados";

export default function ViewGerenciarAnuncioVenda() {
  const { state } = useLocation() as {
    state: { cotaUsuarioId: number; nome: string; usuarioId: number };
  };

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const { cotaUsuario, loading: isLoadingCotaUsuario } = useBuscarCotaUsuario(
    state.cotaUsuarioId
  );

  const { anuncioPropriedade, loading: isLoadinAnuncio } =
    useAnuncioPropriedade(state.cotaUsuarioId);

  const {
    interessadoAnuncio,
    qtdInteressadoAnuncio,
    loading: isLoadingInteressado,
  } = useInteressadoAnuncio(anuncioPropriedade?.id);

  const { visualizacoes, loading: isLoadingVisualizacoes } = useVisualizacao(
    anuncioPropriedade?.id
  );

  const [openModalEditar, setOpenModalEditar] = useState(false);
  const handleModalEditar = () => {
    setOpenModalEditar(!openModalEditar);
  };

  const [openModalInteressados, setOpenModalInteressados] = useState(false);
  const handleModalInteressados = () => {
    setOpenModalInteressados(!openModalInteressados);
  };

  return (
    <Container>
      {isLoadingCotaUsuario &&
      isLoadinAnuncio &&
      isLoadingInteressado &&
      isLoadingVisualizacoes ? (
        <Skeleton active />
      ) : isMobile ? (
        <ViewGerenciarAnuncioVendaMobile
          nomeEmpreend={state.nome}
          dataAnuncio={formatDate(anuncioPropriedade?.dataAnuncio)}
          dataInativacao={formatDate(anuncioPropriedade?.dataInativacaoAnuncio)}
          visualizacoes={visualizacoes}
          qtdInteressados={qtdInteressadoAnuncio}
          valorVenda={cotaUsuario?.valorVenda}
          valorCondominio={cotaUsuario?.valorCondominio}
          situacao={cotaUsuario?.situacao}
          saldoDevedor={cotaUsuario?.saldoDevedor}
          aceitaTroca={cotaUsuario?.aceitaTroca ?? false}
          onClickEditar={handleModalEditar}
          onClickInteressados={handleModalInteressados}
        />
      ) : (
        <ViewGerenciarAnuncioVendaDesktop
          nomeEmpreend={state.nome}
          dataAnuncio={formatDate(anuncioPropriedade?.dataAnuncio)}
          dataInativacao={formatDate(anuncioPropriedade?.dataInativacaoAnuncio)}
          visualizacoes={visualizacoes}
          qtdInteressados={qtdInteressadoAnuncio}
          valorVenda={cotaUsuario?.valorVenda}
          valorCondominio={cotaUsuario?.valorCondominio}
          situacao={cotaUsuario?.situacao}
          saldoDevedor={cotaUsuario?.saldoDevedor}
          aceitaTroca={cotaUsuario?.aceitaTroca ?? false}
          onClickEditar={handleModalEditar}
          onClickInteressados={handleModalInteressados}
        />
      )}

      <ModalEditarAnuncio
        isModalOpen={openModalEditar}
        handleFechar={handleModalEditar}
        cotaUsuarioId={state.cotaUsuarioId}
        valorVenda={cotaUsuario?.valorVenda}
        valorCondominio={cotaUsuario?.valorCondominio}
        situacao={cotaUsuario?.situacao}
        saldoDevedor={cotaUsuario?.saldoDevedor}
        aceitaTroca={cotaUsuario?.aceitaTroca ?? false}
      />

      <ModalInteressados
        isModalOpen={openModalInteressados}
        handleFechar={handleModalInteressados}
        interessadoAnuncio={interessadoAnuncio}
      />
    </Container>
  );
}
